import styled from 'styled-components';

import {border, colors, font} from 'theme';

export const Wrapper = styled.div<{$type: 'unit' | 'transport' | null}>`
    position: sticky;
    left: 0;
    display: ${({$type}) => ($type ? 'flex' : 'none')};
    width: auto;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    background-color: ${({$type}) =>
        $type === 'unit' ? colors.brandLight : colors.successSecondary};
    color: ${({$type}) => ($type === 'unit' ? colors.brandPrimary : colors.darkGrey)};
    border-color: ${({$type}) => ($type === 'unit' ? colors.brandPrimary : colors.success)};
    border-style: solid;
    border-width: 1px;
    border-radius: ${border.radius};
    padding: 10px 20px;
`;

export const BannerSection = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 1px;
`;

export const BannerTitle = styled.h3`
    font-family: ${font.family.primary};
    padding: 0;
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: ${colors.textGrey1};
    line-height: 18px;
    letter-spacing: 0px;
`;

export const BannerDescription = styled.p`
    font-family: ${font.family.primary};
    padding: 0;
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${colors.textSecondary};
    font-style: Regular;
    letter-spacing: 0px;
`;
